import styled from "@emotion/styled";
import { Collapse } from "antd";
import type { ReactNode } from "react";
import React from "react";

import { getExpandIcon } from "./shared";

const { Panel } = Collapse;

interface IProps {
  genBalance: ReactNode;
  genHeader: ReactNode;
  marginTop?: number;
  isInitiallyCollapsed?: boolean;
  children?: React.ReactNode;
}

export const StepComponentWrapperWithChevron: React.FC<IProps> = ({
  children,
  genBalance,
  genHeader,
  marginTop = 0,
  isInitiallyCollapsed = false,
}) => {
  return (
    <div style={{ marginTop: marginTop }}>
      <StyledCollapseWithChevron
        defaultActiveKey={[isInitiallyCollapsed ? "0" : "1"]}
        ghost
        style={{ padding: 0, margin: 0 }}
        expandIcon={getExpandIcon}
        expandIconPosition="end"
      >
        <Panel header={genHeader} key="1" style={{ padding: 0, margin: 0 }} extra={genBalance} showArrow={true}>
          {children}
        </Panel>
      </StyledCollapseWithChevron>
    </div>
  );
};

const StyledCollapseWithChevron = styled(Collapse)`
  .ant-collapse-header {
    display: flex;
    flex-direction: row-reverse;

    > h2 {
      margin: auto auto auto 0;
    }

    .ant-collapse-arrow {
      // Destroy existing styles to allow for flexbox approach
      position: relative !important;
      top: unset !important;
      right: unset !important;
      left: unset !important;
      transform: unset !important;
      // Add in margin
      margin: auto 0 auto auto;

      // Replace existing styles to make in-between container a flexbox
      > div {
        margin: 0;
        height: 100%;
        width: 100%;
        display: flex;

        > svg {
          margin: auto;
        }
      }
    }
  }

  > .ant-collapse-item {
    padding: 0;
    margin: 0;
    > .ant-collapse-content {
      overflow-y: hidden;
      overflow-x: auto;
    }
  }
`;
